import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { loginGuard } from '@core/guards/login.guard';
import { LoginComponent } from '@pages/login/login.component';
import { PagesRoutingModule } from '@pages/pages-routing.module';
import { PostLoginComponent } from '@pages/post-login/post-login.component';

/**
 * Layouts are defined in features/layouts
 * * Main-layout: Toolbar and sidenav
 * Child routes for each layout are defined inn the corresponding module
 */
export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginGuard],
  },
  {
    path: 'callback',
    component: PostLoginComponent,
    canActivate: [loginGuard],
  },
  // Redirect to home if not found
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [PagesRoutingModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
